import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { Sgkd004dSearchResult } from '../../models/sgkd004d-search-result';
import { SelectionModel } from '@angular/cdk/collections';
import { Sgkd016aResponseOutputinfo } from 'sg-api';
import { TimeApiService } from 'cbc-shared-lib';
import { UsedSgkd004dSgkd015aService } from '../../services/used-sgkd004d-sgkd015a.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-sgkd004d-search-result',
  templateUrl: './sgkd004d-search-result.component.html',
  styleUrl: './sgkd004d-search-result.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class Sgkd004dSearchResultComponent implements OnInit, OnDestroy {

  private onDestroy$ = new Subject();

  /** メインフォーム */
  mainForm: UntypedFormGroup;
  /** 結果フラグ */
  hasResult: boolean = false;

  /** メッセージクリア通知イベント */
  @Output() clearMessageEvent = new EventEmitter<string>();
  /** メッセージ設定通知イベント */
  @Output() setMessageEvent = new EventEmitter<string>();

  /** テーブル表示カラム*/
  displayedColumnsCol: string[] = [
    'select',
    'creditRecpNo',
    'acceptDate',
    'acceptbase',
    'acceptorg',
    'tantousha',
    'status',
    'requestType',
    'billingCstmrNo',
    'billingCstmrName'
  ];

  /** 検索結果 */
  dataSource: MatTableDataSource<Sgkd004dSearchResult>;
  /** 選択行情報 */
  selection: SelectionModel<Sgkd004dSearchResult> = new SelectionModel<Sgkd004dSearchResult>(true, []);
  /** 全選択選択状態 */
  checkedAll: boolean = false;

  constructor(
    private parent: FormGroupDirective,
    private usedSgkd004dSgkd015aService: UsedSgkd004dSgkd015aService) {
  }

  /**
   * 初期処理
   * 
   * @memberof Sgkd004dSearchResultComponent
   */
  ngOnInit(): void {
    this.mainForm = this.parent.form;
    //テーブル表示データ作成
    this.dataSource = new MatTableDataSource<Sgkd004dSearchResult>();
  }

  /**
   * 破棄処理
   * 
   * @memberof Sgkd004dSearchResultComponent
   */
  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  /**
   * 検索結果設定
   * 
   * @param resultList 検索結果
   * @memberof Sgkd004dSearchResultComponent
   */
  setResult(resultList: Array<Sgkd016aResponseOutputinfo>): void {

    this.selection.clear(); // 全解除
    this.checkedAll = false;
    this.dataSource = new MatTableDataSource<Sgkd004dSearchResult>();
    resultList.forEach((result, index) => {
      let dispResult = {
        creditRecpNo: result.aceptNo,
        aceptNoAceptbase: result.aceptNoAceptbase,
        acceptDate: this.convertStringToDate(result.aceptTime),
        acceptbase: result.acceptbaseCompany,
        acceptorg: result.acceptbaseSosiki,
        tantousha: result.aceptTntsh,
        status: result.srndocDeliverySts,
        statusCode: result.srndocDeliveryStsCode,
        requestType: result.srndocClsfy,
        requestTypeCode: result.srndocClsfyCode,
        billingCstmrNo: result.payCtrNo,
        billingCstmrName: result.sendtoAddressee,
        postno: result.postno,
        pfcAname: result.pfcAname,
        mptAname: result.mptAname,
        twareaAname: result.townAreaName,
        oazaAname: result.ooazaName,
        chomeanameIkaKanjitext: result.chomeanameIkaKanjitext,
        supadrAname: result.supadrKanjiAname1,
        yagouAname: result.yagouAname,
        extLinkId: result.extLinkId
      }
      this.dataSource.data.push(dispResult);
    });
    this.hasResult = true;
  }

  /**
   * 検索結果行クリック処理
   *
   * @memberof Sgkd010dSearchResultComponent
   */
  clickRow(row: Sgkd004dSearchResult, event: Event): void {

    const target = event.target as HTMLInputElement;
    if (target.className.includes('mat-checkbox-inner-container')) {
      return;
    }

    // 受付基盤UIのURL取得
    const url: string = (window as any).__env.ACEPTBASE_UI_BASE_PATH;
 
    // anyタイプのパラメータ
    let paramToOutside: any = {};
 
    // お客さま番号
    let customerNo: string = row.extLinkId;
    // 支払契約番号
    let paymentContractNo: string = row.billingCstmrNo;
    // 受付番号
    let cursusRecepNum: string = row.aceptNoAceptbase;
 
    // パラメータ設定
    // お客さま番号
    if (customerNo) {
      paramToOutside.c__customerNo = customerNo;
    }
    // 支払契約番号
    if (paymentContractNo) {
      paramToOutside.c__paymentContractNo = paymentContractNo;
    }
    // 受付番号
    if (cursusRecepNum) {
      paramToOutside.c__cursusRecepNum = cursusRecepNum;
    }
    // 起動元画面
    paramToOutside.c__launchSourceScreen = '1';
 
    //  anyタイプをクエリ文字列に変換
    let params: string = new URLSearchParams(paramToOutside).toString();
    if (params) {
      params = '?' + params;
    };
 
    // 別タブで該当URLを開く
    window.open(`${url}${params}`, '_blank');
 
  }

  /**
   * 印刷ボタン押下処理
   * 
   * @memberof Sgkd004dSearchResultComponent 
   */
  onClickPrint(): void {

    this.clearMessageEvent.emit('');

    let outputList = []
    this.selection.selected.forEach((selected) => {
      outputList.push({
        kohuriCreditapplicationAcceptancenumber: selected.creditRecpNo,
        srndocClscode: selected.requestTypeCode,
        sendtoAddressee: selected.billingCstmrName,
        postno: selected.postno,
        pfcAname: selected.pfcAname,
        mptAname: selected.mptAname,
        townAreaName: selected.twareaAname,
        ooazaName: selected.oazaAname,
        chomeanameIkaKanjitext: selected.chomeanameIkaKanjitext,
        supadrKanjiAname1: selected.supadrAname,
        yagouAname: selected.yagouAname,
        recptFixNo: selected.billingCstmrNo
      });
    });

    this.usedSgkd004dSgkd015aService.print(
      outputList, this.mainForm.get('conditionForm').get('acceptbaseSosiki').value)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(response => {
        response.responseCommon.errors.forEach((error) => {
          this.setMessageEvent.emit(error.message);
        });
      }, error => {
      });
  }

  /**
   * チェックボックスチェックON/OFF処理
   * 
   * @memberof Sgkd004dSearchResultComponent 
   */
  selectOne(result: Sgkd004dSearchResult) {
    this.selection.toggle(result);
    if (this.selection.selected.length === this.dataSource.data.length) {
      this.checkedAll = true;
    } else {
      this.checkedAll = false;
    }
  }

  /**
   * 全チェックボックスチェックON/OFF処理
   * 
   * @memberof Sgkd004dSearchResultComponent 
   */
  selectAll() {
    if (this.selection.selected.length === this.dataSource.data.length) {
      this.selection.clear(); // 全解除
      this.checkedAll = false;
    } else {
      this.selection.select(...this.dataSource.data); // 全選択
      this.checkedAll = true;
    }
  }

  /**
   * yyyyMMddHHmm形式の文字列をDate型に変換する
   *
   * @param {string} date
   * @return {*}  {Date}
   * @memberof Sgkd004dSearchResultComponent
   */
  private convertStringToDate(date: string): Date | null {
    let result: Date | null = null;
    if (date && date != '') {
      const yyyy = Number(date.slice(0, 4));
      const MM = Number(date.slice(4, 6)) - 1;
      const dd = Number(date.slice(6, 8));
      const hour = Number(date.slice(8, 10));
      const minute = Number(date.slice(10, 12));
      result = new Date(yyyy, MM, dd, hour, minute);
    }
    return result;
  }
}
